export default {
  isUserMember(user) {
    if (!user) return false

    return user.membershipLevel >= 50
  },
}



// WEBPACK FOOTER //
// ./src/lib/membership.js